module.exports = __webpack_public_path__ + "assets/a852173d193fe82ba7b71b9cf9e10815.mp3";